<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

<salonmonster-tap-retry
  *ngIf="errorOccurred"
  (click)="processQuickLogin()"
></salonmonster-tap-retry>
